import { MAX_SEARCH_RESULT_NUMBER } from 'FRONTEND/utils/constants';
import { apiStatusError, fetchError } from 'FRONTEND/utils/errors';
import {
  API_PATIENT_PATH,
  API_PATIENT_CREATE_PATH,
  API_PATIENT_UNIQUE_PATH,
  getApiPatientUpdatePath,
} from 'FRONTEND/utils/routes';

const formatPatient = (rawPatient) => {
  return {
    logicalId: rawPatient.id,
    id: rawPatient.patient_id,
    tenantId: rawPatient.tenant_id,
    firstname: rawPatient.first_name,
    lastname: rawPatient.last_name,
    email: rawPatient.email,
    phoneNumber: rawPatient.phone_number,
    picture: rawPatient.picture,
    gender: rawPatient.gender,
    birthdate: rawPatient.birthdate,
    birthplaceInsee: rawPatient.birthplace_insee,
  };
};

export async function getPatients({ name, limit = MAX_SEARCH_RESULT_NUMBER }) {
  try {
    const params = new URLSearchParams({
      _q: name,
      limit,
      active: 'true',
      deceased: 'false',
    });
    const response = await fetch(`${API_PATIENT_PATH}?${params}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }).then((data) => {
      apiStatusError({ response: data });
      return data.json();
    });

    return response.patients
      .filter((patient) => patient.first_name && patient.last_name)
      .map(formatPatient);
  } catch (error) {
    throw fetchError({ error });
  }
}

export async function getUniquePatient(patient) {
  const apiURL = new URL(API_PATIENT_UNIQUE_PATH, 'https://placeholder');
  Object.keys(patient).forEach((key, _index) => {
    apiURL.searchParams.append(key, patient[key]);
  });

  try {
    return await fetch(`${apiURL.pathname}${apiURL.search}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    }).then((data) => {
      return data.json();
    });
  } catch (error) {
    throw fetchError({ error });
  }
}

export async function createPatient({ patientFormData }) {
  try {
    const rawPatient = await fetch(API_PATIENT_CREATE_PATH, {
      method: 'POST',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        Prefer: 'return=representation',
      },
      body: patientFormData,
    }).then((data) => {
      return data.json();
    });
    return formatPatient(rawPatient);
  } catch (error) {
    throw fetchError({ error });
  }
}

export async function updatePatient({ patientFormData, logicalId }) {
  try {
    const data = await fetch(getApiPatientUpdatePath(logicalId), {
      method: 'POST',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        Prefer: 'return=representation',
      },
      body: patientFormData,
    });

    if (data.status >= 400) {
      throw new Error('patient_update_failed');
    }
    const rawPatient = await data.json();
    return formatPatient(rawPatient);
  } catch (error) {
    throw fetchError({ error });
  }
}
